module.exports = __webpack_public_path__ + "img/tick.6d341784.svg";